import { render } from "./bubble-menu.vue?vue&type=template&id=b4522530"
import script from "./bubble-menu.vue?vue&type=script&lang=js"
export * from "./bubble-menu.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__